import React, { useEffect, useState } from "react";
import { func, string } from "prop-types";
import { m } from "framer-motion";
import "antd/dist/antd.css";
import "./styles.css";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";

const Toggle = ({ theme, toggleTheme }) => {
  const [isChecked, setIsChecked] = useState(theme === "dark");

  useEffect(() => {
    setIsChecked(theme === "dark");
  }, [theme]);

  const themeToSet = isChecked ? "Light" : "Dark";

  return (
    <div className="slider-container-dark">
      <div className="flex-col">
        <m.button
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          className="gesture-switch"
          onClick={toggleTheme}
        >
          <ToggleSwitch
            optionLabels={["L", "D"]}
            checked={isChecked}
            onChange={toggleTheme}
            id={"theme-switch"}
            name={"App Themes"}
          />
        </m.button>
        <em>{`${themeToSet} mode!`}</em>
      </div>
    </div>
  );
};
Toggle.propTypes = {
  theme: string.isRequired,
  toggleTheme: func.isRequired,
};
export default Toggle;
